import type { FC } from 'react';
import { IoCalendarOutline, IoCheckmarkOutline } from 'react-icons/io5';

import { Flex, Menu } from '@mantine/core';

import { Event } from 'models';

import { InlineFilters } from 'components/component-overview/inline-filters/InlineFilters';
import { useActiveEvents } from 'hooks/use-active-events';
import { useLocalEvent } from 'hooks/use-local-event';

const InlineFiltersEvent: FC = () => {
    const { events } = useActiveEvents();
    const { localEvent, setLocalEvent } = useLocalEvent();

    const onClick = (id: Event['id']) => {
        setLocalEvent(id);
    };

    const onRemove = () => {
        setLocalEvent(null);
    };

    return events.length || localEvent ? (
        <InlineFilters.Section
            label={
                localEvent ? (
                    <Flex mr={4}>
                        <IoCalendarOutline />
                    </Flex>
                ) : (
                    <Flex align="center" gap={8}>
                        <IoCalendarOutline /> Event
                    </Flex>
                )
            }
            body={localEvent?.name}
            onRemove={localEvent ? onRemove : undefined}
            active={Boolean(localEvent)}
            popoverContent={
                events.length ? (
                    <>
                        <Menu.Label>Events</Menu.Label>
                        {events.map(({ id, name }) => (
                            <Menu.Item
                                key={id}
                                onClick={() => onClick(id)}
                                leftSection={localEvent?.id === id ? <IoCheckmarkOutline /> : null}
                            >
                                {name}
                            </Menu.Item>
                        ))}
                    </>
                ) : null
            }
        />
    ) : null;
};

export { InlineFiltersEvent };
